export default "__VITE_ASSET__DjTjrVG7__"